import { render, staticRenderFns } from "./DateWrapper.vue?vue&type=template&id=dbd1f122"
import script from "./DateWrapper.vue?vue&type=script&lang=js"
export * from "./DateWrapper.vue?vue&type=script&lang=js"
import style0 from "./DateWrapper.vue?vue&type=style&index=0&id=dbd1f122&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports